import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialTiktokRoundedIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.7844 5.41922C14.9539 6.33524 15.4977 7.12083 16.2507 7.61195C16.7749 7.95408 17.401 8.15324 18.0722 8.15324V10.5572C16.8256 10.5572 15.6703 10.1584 14.7277 9.48162V14.3667C14.7277 16.8068 12.7426 18.7913 10.3031 18.7913C9.35997 18.7913 8.48609 18.4944 7.76722 17.9897C6.62646 17.1891 5.87849 15.8642 5.87849 14.3672C5.87849 11.9277 7.86354 9.94264 10.3031 9.94264C10.5058 9.94264 10.7044 9.9592 10.8996 9.98579V12.4399C10.7104 12.3807 10.5113 12.3466 10.3031 12.3466C9.18891 12.3466 8.28242 13.2531 8.28242 14.3672C8.28242 15.1428 8.72287 15.817 9.366 16.1556C9.64642 16.3031 9.96497 16.3879 10.3031 16.3879C11.3917 16.3879 12.2791 15.5221 12.3197 14.443L12.3238 4.8092H14.7277C14.7277 5.01739 14.7478 5.22106 14.7844 5.41922Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
